import { BaseResponse } from '@utils/types/shared/base.ts';

export enum ExportTemplateItemStatus {
  NOT_RUNNING = 'NOT_RUNNING',
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  ERROR = 'ERROR'
}

export enum ExportTemplateItemJobType {
  BACKGROUND_JOB = 'BACKGROUND_JOB'
}

export type ExportTemplateItem = {
  id: number;
  status: ExportTemplateItemStatus;
  job_type: ExportTemplateItemJobType;
  error_message: string | null;
  document_id: number;
  document_filename: string;
  export_template_id: number;
  export_template_name: string;
  created_by_id: number;
  created_by_full_name: string;
  date_started: string | null;
  date_finished: string | null;
  created_at: string;
  api_calls_made: number;
  has_file: boolean;
};

export type ExportTemplateItemsResponse = BaseResponse<ExportTemplateItem[]>;

export type ExportTemplateItemResponse = BaseResponse<ExportTemplateItem>;

export type ExportTemplateItemDownloadUrlResponse = {
  download_url: string;
  filename: string;
  expires_in_seconds: number;
};
